import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import { firestore } from '../../config/firebase';
import { fetchExpenses, deleteExpense } from '../../store/actions/expenseActions';
import Pagination from 'rc-pagination';
import 'rc-pagination/assets/index.css';
import ExpenseItem from './ExpenseItem/ExpenseItem';
import Spinner from '../UIComponents/Spinner';
import lang from './lang';
import './Expenses.css';


class Expenses extends Component {
    state = { display: 'flex', totalItems: 0, currentData: [], pageSize: 10 }

    componentDidMount() {
        this.setState({
            totalItems: this.props.expenses.length,
            currentData: this.props.expenses.slice(0, this.state.pageSize),
            display: 'none'
        });

        if (this.props.user.id) {
            firestore.collection("users").doc(this.props.user.id)
                .collection('expenses')
                .onSnapshot((doc) => {
                    let expenses = [];
                    doc.forEach(item => expenses.push({ ...item.data(), id: item.id }))
                    this.props.fetchExpenses(expenses);
                });
        } else {
            firestore.collection("users").doc(this.props.user.id || 'default')
                .collection('expenses')
                .onSnapshot((doc) => {
                    let expenses = [];
                    doc.forEach(item => expenses.push({ ...item.data(), id: item.id }))
                    this.props.fetchExpenses(expenses);
                });
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.expenses.length !== prevProps.expenses.length) {
            this.forceUpdate();
            this.setState({
                totalItems: this.props.expenses.length,
                currentData: this.props.expenses.slice(0, this.state.pageSize),
            });
        }
    }

    removeExpenseHandler = (id) => {
        this[id + 'Ref'].classList.add('remove-me');
        setTimeout(() => {
            this.setState(prevState => {
                return { currentData: prevState.currentData.filter(i => i.id !== id) }
            });

            firestore.collection('users').doc(this.props.user.id).collection('expenses')
                .doc(id).delete().then(doc => {
                    this.props.deleteExpense(id);
                })
        }, 500)

    }

    pageHandler = (page) => {
        const startPosition = this.state.pageSize * page - this.state.pageSize;
        const endPosition = this.state.pageSize * page <= this.state.totalItems ? (this.state.pageSize * page) : this.state.totalItems;
        this.setState({
            currentData: this.props.expenses.slice(startPosition, endPosition)
        })
    }

    linkHandler = (id) => {
        this.props.history.push(`/expenses/${id}`)
    }

    render() {
        const { newBtn, title, name, date, total, type, actions } = lang[this.props.user.lang || 'en'];
        return (
            <div className="container" id="expenses-page">
                <Spinner display={this.state.display} />
                <div className="text-right my-3">
                    <Link to="/expenses/new" className="btn btn-outline-success rounded-pill px-4">+ {newBtn}</Link>
                </div>
                <h2 className="text-center">{title}</h2>
                <table className="table table-striped table-responsive-sm table-hover">
                    <thead className="thead-dark">
                        <tr>
                            <th>#</th>
                            <th>{name}</th>
                            <th>{date}</th>
                            <th>{total}</th>
                            <th>{type}</th>
                            <th>{actions}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.state.currentData.map((item, index) => {
                            return (
                                <ExpenseItem
                                    data={item}
                                    key={item.id}
                                    index={index}
                                    elRef={(ref) => this[item.id + 'Ref'] = ref}
                                    link={this.linkHandler}
                                    remove={this.removeExpenseHandler}
                                />
                            )
                        })}
                    </tbody>
                </table>

                <Pagination
                    showTotal={(total, range) => `${range[0]} - ${range[1]} of ${total} items`}
                    total={this.state.totalItems}
                    pageSize={this.state.pageSize}
                    onChange={(page) => this.pageHandler(page)}
                    hideOnSinglePage={true}
                />
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        user: state.user,
        expenses: state.expenses.expenses.sort((a, b) => b.createdAt - a.createdAt)
    }
}

const mapDispatchToProps = dispatch => {
    return {
        fetchExpenses: (data) => dispatch(fetchExpenses(data)),
        deleteExpense: (id) => dispatch(deleteExpense(id))
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Expenses));